


















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { omegaup } from '../../omegaup';
import { types } from '../../api_types';
import T from '../../lang';
import homepage_Carousel from './Carousel.vue';
import homepage_CoderOfTheMonth from './CoderOfTheMonth.vue';
import homepage_SchoolOfTheMonth from './SchoolOfTheMonth.vue';
import homepage_Testimonials from './Testimonials.vue';
import homepage_Section from './Section.vue';
import school_Rank from '../schools/Rank.vue';
import user_Rank from '../user/Rank.vue';
import homepage_Sponsors from './Sponsors.vue';
import homepage_Cookie from './CookieConsent.vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies, { expire: -1 });

@Component({
  components: {
    'omegaup-carousel': homepage_Carousel,
    'omegaup-coder-of-the-month': homepage_CoderOfTheMonth,
    'omegaup-school-of-the-month': homepage_SchoolOfTheMonth,
    'omegaup-school-rank': school_Rank,
    'omegaup-user-rank': user_Rank,
    'omegaup-testimonials': homepage_Testimonials,
    'omegaup-section': homepage_Section,
    'omegaup-sponsors': homepage_Sponsors,
    'omegaup-cookie-accept-decline': homepage_Cookie,
  },
})
export default class Homepage extends Vue {
  @Prop() coderOfTheMonth!: types.UserProfile;
  @Prop() coderOfTheMonthFemale!: types.UserProfile;
  @Prop() schoolOfTheMonth!: omegaup.SchoolOfTheMonth;
  @Prop() currentUserInfo!: omegaup.User;
  @Prop() rankTable!: omegaup.UserRankTable;
  @Prop() schoolsRank!: omegaup.SchoolRankTable;
  @Prop() isUnder13User!: boolean;

  T = T;
  cookieClickedAccept() {
    // TODO: make an API to send the response to the server
    this.$cookies.set('accept-cookies', true, -1);
  }

  cookieClickedDecline() {
    // TODO: make an API to send the response to the server
    this.$cookies.set('accept-cookies', false, -1);
  }

  cookieClickedPostpone() {
    // TODO: make an API to send the response to the server
  }
}
